import { map } from "lodash";
import { PropTypes } from "prop-types";
import { Component } from "react";
import { Link } from "react-router";
import { toNorwegianDatetime } from "../../utils/date";
import Table from "../Common/Tables/BaseTable";
import innsynSitePaths from "src/constants/SitePaths/innsynSitePaths";

class InnsynIleggelserList extends Component {
  static propTypes = {
    body: PropTypes.object,
  };

  joinOvertredelser = (i) => {
    return [i.overtredelse1, i.overtredelse2, i.overtredelse3]
      .filter(Boolean)
      .join(" / ");
  };
  render() {
    const header = [
      "Ilegg.nr.",
      "Ilegg.dato",
      "Klokkeslett",
      "Overt.kode",
      "Kj.merke",
      "Gatenavn",
      "Ileggelsestype",
    ];

    const ileggelser = this.props.body ? this.props.body.items : [];
    return (
      <Table headerRow={header} defaultStyle>
        <tbody>
          {map(ileggelser, (i, index) => {
            return (
              <tr key={index}>
                <td>
                  <Link
                    to={innsynSitePaths.ileggelser.detalj.shortUrl.replace(
                      ":id",
                      i.id,
                    )}
                  >
                    {i.ileggelsesnummer}
                  </Link>
                </td>
                <td>
                  {i.ileggelsesdatoFra &&
                    toNorwegianDatetime(i.ileggelsesdatoFra).format(
                      "DD.MM.YYYY",
                    )}
                </td>
                <td>
                  {i.ileggelsesdatoFra &&
                    toNorwegianDatetime(i.ileggelsesdatoFra).format(
                      "HH:mm",
                    )}{" "}
                  {i.ileggelsesdatoTil &&
                    ` - ${toNorwegianDatetime(i.ileggelsesdatoTil).format(
                      "HH:mm",
                    )}`}
                </td>
                <td>{this.joinOvertredelser(i)}</td>
                <td>{i.kjennemerke}</td>
                <td>{i.gatenavn}</td>
                <td>{i.type}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default InnsynIleggelserList;
